import React from "react";
import "./_comingSoon.scss";

/** Placeholder panel for foundation portal pages not yet wired to real data. */
const ComingSoon = ({ title }) => (
  <div className="fdn-soon">
    <div className="fdn-soon-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </svg>
    </div>
    <h2 className="fdn-soon-title">{title}</h2>
    <p className="fdn-soon-text">This section is coming soon.</p>
  </div>
);

export default ComingSoon;
